<template>
  <div>
    <vs-input icon-no-border
              v-model="search"
              icon-pack="feather"
              icon="icon-search"
              size="large"
              class="w-full mt-6 mb-5"/>
    <vs-table max-items="10" pagination :data="searchEvents">
      <template slot="thead">
        <vs-th>Email</vs-th>
        <vs-th>Name</vs-th>
        <vs-th>Handynummer</vs-th>
        <vs-th>strasse</vs-th>
        <vs-th>Posleitzahl</vs-th>
        <vs-th>Ort</vs-th>
        <vs-th>Buchung</vs-th>
        <vs-th>Aktionen</vs-th>
        <!--<vs-th>Aktionen</vs-th>-->
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].email">
            {{data[indextr].email}}
          </vs-td>
          <vs-td :data="data[indextr].username">
            {{data[indextr].firstname}} {{data[indextr].lastname}}
          </vs-td>
          <vs-td :data="data[indextr].username">
            {{data[indextr].phone}}
          </vs-td>
          <vs-td :data="data[indextr].username">
            {{data[indextr].street}}
          </vs-td>
          <vs-td :data="data[indextr].username">
            {{data[indextr].postalcode}}
          </vs-td>
          <vs-td :data="data[indextr].username">
            {{data[indextr].city}}
          </vs-td>
          <vs-td :data="data[indextr].id">
            <vs-button @click="goToCustomerReservation(data[indextr].id)" color="primary" type="filled">Buchungen</vs-button>
          </vs-td>
          <vs-td :data="data[indextr].id">
            <vs-button @click="disableUser(data[indextr].id)" color="danger" type="filled" v-if="data[indextr].isactive == 1">Sperren</vs-button>
            <vs-button @click="enableUser(data[indextr].id)" color="success" type="filled" v-if="data[indextr].isactive == 0">Freigeben</vs-button>
          </vs-td>
          <!--<vs-td :data="data[indextr].username">
            <vs-button
              @click="openAlert('danger')"
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-trash"/>
          </vs-td>-->
        </vs-tr>
      </template>
      <template #footer>
    <vs-pagination v-model="currentPage" :length="totalRows" :per-page="perPage" @change="paginateData" />
  </template>
    </vs-table>
  </div>
</template>

<script>

  import {mapActions, mapGetters} from 'vuex'

  export default {
    data() {
      return {
        search: '',
        customers: [],
        reservations: []
      }
    },
    methods: {
      ...mapActions(['fetchAllUsers']),
      ...mapActions(['changeUserStatus']),
      ...mapActions(['setIsLoading']),
      goToCustomerReservation(id){
        this.$router.push({name: 'reservations',params: { type: 'user', id: id }})
      },
      disableUser(userId) {
        let payload = {
          id: userId,
          isActive: 0
        }
        this.changeUserStatus(payload).then(() => {
          this.$router.go(this.$router.currentRoute)
        })
      },
      enableUser(userId) {
        let payload = {
          id: userId,
          isActive: 1
        }
        this.changeUserStatus(payload).then(() => {
          this.$router.go(this.$router.currentRoute)
        })
      },
      openAlert() {
        this.$vs.dialog({
          color: 'danger',
          title: `Sind Sie sicher?`,
          text: 'Sind Sie sicher, dass Sie diese Benutzer löschen möchten?',
          accept: this.acceptAlert,
          acceptText: 'JA'
        })
      },
      acceptAlert() {
        this.$toast.error('Benutzer glöschet')
      }
    },
    mounted() {
      this.setIsLoading(true)
      this.fetchAllUsers().then(() => {
          this.customers = this.getAllUsers
          this.setIsLoading(false)
      })
    },
    computed: {
      ...mapGetters(['getAllUsers']),
      searchEvents() {
        return this.customers.filter((customer) => {
          let customerName = customer.firstname + ' ' + customer.lastname;
          return customerName.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || customer.email.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
        });
      }
    }
  }

</script>
